import SubSequenceSidePanel from './SubSequenceSidePanel.js';
import SidePanelToolbar from './SidePanelToolbar.js';
import { connect } from "react-redux";
import {getIsSelected} from './selectors.js';
import React, { useState } from 'react';
import {StickyContainer, Sticky} from 'react-sticky';
import {
    NO_SUB_SEQUENCE
    } from 'session/constants.js';

function SidePanelContainer(props) {
    let rollClassName = "pattern-info";
    if (props.isRollSelected) {
        rollClassName += ' selected';
    }
    /*
         */
 
    return (
        <div className="side-panel-container">
          <SidePanelToolbar
            scrollContainer={props.scrollContainer}
            sequencerEngine={props.sequencerEngine}/>
         {props.sequencerEngine.subSequences
              .filter(s => !s.isTrack)
              .map(
              (subSequence, i) =>
          <SubSequenceSidePanel i={i} sequencerEngine={props.sequencerEngine} subSequence={subSequence}/>)}
        {props.sequencerEngine.subSequences
              .filter(s => s.isTrack)
              .map(
              (subSequence, i) =>
          <SubSequenceSidePanel i={i} sequencerEngine={props.sequencerEngine} subSequence={subSequence}/>)}
            <div className={rollClassName}>
            <div className="roll sub-sequence-name">
              ROLL
            </div>
            </div>
        </div>
    );
 
}
const mapStateToProps = (state, props) => {
    let id = props.sequencerEngine.engineId;
    return {
        isRollSelected: getIsSelected(state, props),
        subSequences: state.sequencer.subSequences[id],
    };
};
 
export default connect(mapStateToProps, null)(SidePanelContainer);
